/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-13 08:58:58
 * @LastEditTime: 2022-03-24 19:07:53
 */
import i18n from "@/common/lang";
export const Columns = [
  { LabelName: i18n.t('lang.devicelist.SerialNumber'), row: 108, align: 'center', key: 0, ColumnsKey: 'Index', slot: true },
  { LabelName: i18n.t('lang.terminalList.name'), key: 1, ColumnsKey: 'name', seek: 'name', sort: 'custom' },
  { LabelName: i18n.t('lang.terminalList.serialNumber'), key: 2, ColumnsKey: 'dsn', row: 160, sort: 'custom', seek: 'dsn', },
  // { LabelName: 'SN', key: 2, ColumnsKey: 'sn',row: 200, placeholder: i18n.t('lang.devicelist.search1'), sort: 'custom',seek: 'sn', },
  // { LabelName: 'did', key: 3, ColumnsKey: 'did', seek: 'did', sort: 'custom' },
  { LabelName: i18n.t('lang.terminalList.templateName'), key: 4, ColumnsKey: 'mname', row: 140,sort: 'custom', seek: 'mname', },
  { LabelName: i18n.t('lang.terminalList.protocol'), key: 5, ColumnsKey: 'protocol', isCustom: true, seek: 'protocol', select: true, selectOptions: [{ value: "1", label: "Modbus TCP" }, { value: "2", label: "Modbus RTU" }, { value: "3", label: "IO Control" }] },
  // { LabelName: i18n.t('lang.devicelist.statevoid'), align: 'center', key: 6, ColumnsKey: 'state', Tag: true, placeholder: i18n.t('lang.devicelist.search5'), Fun: 'GetStatus'},
  { LabelName: i18n.t('lang.terminalList.describe'), key: 7, ColumnsKey: 'description' },
]

export const ColuumnsButton = [
  { key: 0, type: 'primary', icon: 'el-icon-setting', Fun: 'showVariable', Authority: 53, tipValue: i18n.t('lang.Monitor.setVariable'), },
  { key: 1, type: 'primary', icon: 'icon-chaxun', Fun: 'showDetail', Authority: 53, tipValue: i18n.t('lang.terminalList.details'), },
  { key: 2, type: 'primary', icon: 'el-icon-edit', Fun: 'editTerminal', Authority: 239, tipValue: i18n.t("lang.openvpn.edit"), },
  { key: 3, type: 'danger', icon: 'el-icon-delete', Fun: 'deleteTerminal', Delete: true, Authority: 240 },
]
